/**
 * The transfer types that Slate recognizes.
 *
 * @type {Object}
 */

export default {
  FRAGMENT: 'application/x-slate-fragment',
  HTML: 'text/html',
  NODE: 'application/x-slate-node',
  RICH: 'text/rtf',
  TEXT: 'text/plain',
}
